import styled from 'styled-components';

export const CalendarIcon = styled.img`
  margin-right: 12px;
`;

export const GrowthIcon = styled.img`
  margin-left: auto;
`;
